<template>
  <section class="limit-section">
    <!-- titre + description spécifique à la catégorie -->
    <!-- panels Jour/Semaine/Mois -->
    <PeriodPanels
      :content="content"
      :periods="nosPeriods"
      :category="category"
      :current-period="currentPeriod"
      @select="openPeriod"
    />
  </section>
</template>

<script>
import PeriodPanels from '@/components/compte/bienJouer/PeriodPanels.vue';

export default {
  name: 'LimitSection',
  components: { PeriodPanels }, // , ConditionsInfo
  props: {
    content: { type: Object, required: false },
    category: { type: String },
    limitValues: { type: Object },
  },
  data() {
    return {
      nosPeriods: null,
      currentPeriod: null,
    };
  },
  watch: {
    // fermer tous les formulaires lors du changement d'onglet
    category() {
      this.currentPeriod = null;
    },
  },
  mounted() {
    // Afficher le spinner au chargement de la page sauf dans Magnolia
    this.nosPeriods = Object.keys(this.limitValues);
    if (this.category === 'deposit') {
      // eslint-disable-next-line prefer-destructuring
      this.currentPeriod = this.nosPeriods[0];
    }
  },
  methods: {
    openPeriod(period) {
      // toggle: ouvre ou ferme le formulaire associé
      this.currentPeriod = this.currentPeriod === period ? null : period;
    },
  },
};
</script>
